import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export type AutoSelectionSettingKey = 'isDorimPromoOnly';
export type AutoSelectionSettingsConfig = Record<AutoSelectionSettingKey, boolean>;

type AutoSelectionSettingsConfigStore = {
  settingsConfig: AutoSelectionSettingsConfig;

  actions: {
    setAutoSelectionSettingsConfig: (settingsConfig: AutoSelectionSettingsConfig) => void;
  };
};

export const useSettingsConfigStore = create<AutoSelectionSettingsConfigStore>()(
  devtools(
    persist(
      set => ({
        settingsConfig: {
          isDorimPromoOnly: false,
        },

        actions: {
          setAutoSelectionSettingsConfig: settingsConfig =>
            set({ settingsConfig }, false, 'setAutoSelectionSettingsConfig'),
        },
      }),
      {
        name: 'auto-selection-settings-config-store',
        partialize: state => ({
          settingsConfig: state.settingsConfig,
        }),
      },
    ),
    {
      name: 'auto-selection-settings-config-store',
      enabled: import.meta.env.DEV,
    },
  ),
);

export const useAutoSelectionSettingsStoreActions = () => useSettingsConfigStore(state => state.actions);

export const useAutoSelectionSettingsConfig = () => useSettingsConfigStore(state => state.settingsConfig);
